import { useEffect, useRef, useState } from "react";
import { STATS } from "@/lib/site";

export default function Stats() {
  const [active, setActive] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setActive(true)),
      { threshold: 0.3 }
    );
    if (ref.current) io.observe(ref.current);
    return () => io.disconnect();
  }, []);

  return (
    <section
      id="esperienza"
      ref={ref}
      data-testid="stats-section"
      className="relative py-24 lg:py-28 bg-brand-surface"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-12">
          <div className="lg:col-span-7 reveal">
            <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-bold text-brand-primary">
              <span className="w-8 h-px bg-brand-primary" />
              I numeri
            </div>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brand-ink mt-4 text-balance">
              Esperienza che si vede.<br />
              <span className="text-brand-primary">Fiducia che si sente.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pl-10 reveal reveal-delay-1">
            <p className="text-lg text-brand-body leading-relaxed">
              Quasi due decenni a fianco delle famiglie e delle imprese siciliane. Ogni numero è una storia.
              Ogni storia è un cliente che ci ha scelto, di nuovo.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-brand-line border border-brand-line rounded-2xl overflow-hidden">
          {STATS.map((s, i) => (
            <div
              key={s.label}
              data-testid={`stat-${i}`}
              className={`bg-white p-6 sm:p-8 lg:p-10 ${active ? "counter-pop" : "opacity-0"}`}
              style={{ animationDelay: `${i * 120}ms` }}
            >
              <div className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brand-primary leading-none">
                {s.value}
              </div>
              <div className="mt-3 sm:mt-4 text-xs sm:text-sm uppercase tracking-[0.16em] sm:tracking-[0.18em] font-semibold text-brand-body">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
